import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { inject, signal } from '@angular/core';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { ConfigService } from '../services/config.service';
import { ApiHealthService } from '../../services/api.health.service';

// This guard relies on the ApiHealthService's connection BehaviorSubject
const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles, keycloak } = authData;
  const router = inject(Router);
  const config: ConfigService = inject(ConfigService);
  const _isConnected = signal(false);

  inject(ApiHealthService).connection.subscribe((r) => {
    _isConnected.set(r);
  });

  // Get the latest connection status from the Observable

  // Check if API is available based on the connection status
  if (!_isConnected()) {
    return router.parseUrl('/error');
  }

  // Continue with authentication check
  if (!authenticated) {
    await keycloak.login();
    return false;
  }

  const requiredRole = route.data['roles'];

  if (!requiredRole) {
    return true;
  }

  const clientRoles = grantedRoles.resourceRoles[config.clientId];

  if (!clientRoles) {
    return router.parseUrl('/');
  }

  if (authenticated && clientRoles.some((x) => requiredRole.includes(x))) {
    return true;
  }

  return router.parseUrl('/');
};

export const canActivateAuthRole =
  createAuthGuard<CanActivateFn>(isAccessAllowed);
